import React from 'react';
import {connect} from 'react-redux'
import { saveAs } from 'file-saver';
import encoding from 'encoding-japanese';

import Paper from 'material-ui/Paper';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import * as colors from 'material-ui/styles/colors';

import PageBase from '../../../components/PageBase';

import gStyles from '../../../styles'

import * as actions from '../../../actions'
import SystemControllMasterForm from './SystemControllMasterForm'
import _ from 'lodash'

import Loading from '../../../components/Loading';

import $ from 'jquery'

import moment from 'moment'

class SystemControllMasterPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      open: false,
      values: {}
    }
  }


  componentDidMount() {

    $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
      // check for conditions and support for blob / arraybuffer response type
      if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
        return {
          // create new XMLHttpRequest
          send: function (headers, callback) {
            // setup all variables
            var xhr = new XMLHttpRequest(),
              url = options.url,
              type = options.type,
              async = options.async || true,
              // blob or arraybuffer. Default is blob
              dataType = options.responseType || "blob",
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', function () {
              var data = {};
              data[options.dataType] = xhr.response;
              // make callback and send data
              callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, url, async, username, password);

            // setup custom headers
            for (var i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort: function () {
            jqXHR.abort();
          }
        };
      }
    });

  }

  handleDownloadEnd() {
    this.setState(Object.assign(this.state, { loading: false }));
  }

  handleDownloadStart() {
    this.setState(Object.assign(this.state, { loading: true }));
  }

  handleDownload(start, end) {

    return function (values) {

      start()

      const startDate =  values.start ? moment(new Date(values.start)).format('YYYY/MM/DD'): "";
      const endDate = values.end ? moment(new Date(values.end)).format('YYYY/MM/DD') : "";

      $.ajax({
        url: `/bg/systemControll/download?start=${startDate}&end=${endDate}`,
        dataType: "text",
        processData: false,
        error: function () {
        },
        success: function (data) {

          end()

          const name = '代休.csv'

          const unicodeList = [];
          for (let i = 0; i < data.length; i += 1) {
            unicodeList.push(data.charCodeAt(i));
          }

          // 変換処理の実施
          const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
          const uInt8List = new Uint8Array(shiftJisCodeList);

          // csv書き込みの実装
          const writeData = new Blob([uInt8List], { type: 'text/csv' });

          saveAs(writeData, name);

          return;

          // const mimeType = 'text/csv; charset=SHIFT-JIS'
          //
          // let blob = new Blob([data], {type: mimeType})
          // let downloadUrl = URL.createObjectURL(blob);
          //
          // let a = document.createElement("a");
          // a.href = downloadUrl
          // a.download = name
          // // a.target = '_blank'
          //
          // if (window.navigator.msSaveBlob) {
          //   // for IE
          //   window.navigator.msSaveBlob(blob, name)
          // } else if (window.URL && window.URL.createObjectURL) {
          //   // for Firefox
          //   a.href = window.URL.createObjectURL(blob);
          //   document.body.appendChild(a);
          //   a.click();
          //   document.body.removeChild(a);
          // } else if (window.webkitURL && window.webkitURL.createObject) {
          //   // for Chrome
          //   a.href = window.webkitURL.createObjectURL(blob);
          //   a.click();
          // } else {
          //   // for Safari
          //   window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          // }

        },
        type: 'GET'
      });

    }

  }


  handleConfirmOpen(values) {
    this.setState(Object.assign({}, this.state, {
      open: true,
      values
    }))
  }

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false,
      values: {}
    }))
  }

  render() {

    const {
      form,
      handleSubHolidayClear,
    } = this.props

    const dialogActions = [
      <FlatButton
        label="キャンセル"
        primary={true}
        onTouchTap={this.handleConfirmClose.bind(this)}
      />,
      <FlatButton
        label="削除"
        primary={true}
        keyboardFocused={true}
        onTouchTap={handleSubHolidayClear(this.state.values)}
      />,
    ];

    return (

      <PageBase title="代休操作" >

        <div>

          <Paper style={{...gStyles.contentsPaper}}>
            <SystemControllMasterForm 
              initialValues={form}
              onSubHolidayClear={this.handleConfirmOpen.bind(this)}
              onDownload={this.handleDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this)).bind(this)}
            />
          </Paper>

        </div>

        <Loading open={this.state.loading}/>

        <Dialog
          title="代休削除"
          actions={dialogActions}
          modal={true}
          open={this.state.open}
          onRequestClose={this.handleConfirmClose.bind(this)}
        >
          全ての社員の代休情報を削除します。よろしいですか？
        </Dialog>

      </PageBase>

    )
  }

}

const mapStateToProps = (state) => ({
  form: state.systemControll.form
})

const mapStateToDispatch = (dispatch) => ({
  handleSubHolidayClear : (values) => () => {
    dispatch(actions.userSystemControllSubHolidayClear(values))
  },
})

SystemControllMasterPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(SystemControllMasterPage)

export default SystemControllMasterPage;



// WEBPACK FOOTER //
// ./src/containers/master/systemControll/SystemControllMasterPage.js